export default {
  public: "公开",
  re_new: "更新",
  live_preview: {
    auction_overview: "拍卖概要",
    period: "举办时间",
    end_time_varies: "因锦鲤不同，结束时间不同",
    attention: `<p class="mb__text-lg mb__text-center">关于预留锦鲤</p><p class="mb__m-bottom-sm">出品锦鲤的说明栏内<span class="EM">没有记载包含预留费、可以预留的锦鲤，原则上不能预留。</span><br>因迫不得已的原因希望长期预留的顾客，请务必在竞拍前通过邮件或电话联系我们。<br>另外，长期预留锦鲤的情况下，<span class="EM">我们不承诺预留期间的任何死亡保证</span>，请您在知悉该情况的基础上，提出要求。</p><p class="mb__asterisk">我们销售的保证是母鱼的锦鲤，在发现是公鱼时，我们将全额退款。</p>`,
    auction_carp_list: "拍卖锦鲤列表",
    all_producers: "所有生产者",
    fish_farm: "🍧玉浦養魚場🍧",
    koi_farm: "🍧面迫養鯉場🍧",
    all_breeds: "所有品种",
    read_and_white: "🍧紅白🍧",
    taisho_three_colors: "🍧大正三色🍧",
    all_genders: "所有性别",
    male: "オス",
    female: "メス",
    unknown: "不明",
    price: "价格",
    the_following: "以下",
    show_only_the_koi_you_bid_on: "仅显示竞拍的锦鲤",
    display: "显示",
    reset: "重置",
    in_the_case: "件中",
    view: "显示 件",
    list: "清单",
    thumbnail: "小窗口",
    submitted_from_narita_fish_farm: "🍧成田養魚園より出品🍧",
    parent_carp: "🍧親鯉🍧",
    remaining: "剩余",
    starting_price: "开始价格",
    current_price: "现在价格",
    photograph: "照片",
    movie: "视频",
    favorite: "收藏夹",
    bid: "🍧入札🍧",
    bid_content: "竞拍下述拍卖的出品锦鲤的话，请输入出价金额点击出价按键。",
    favorite_button: "收藏夹",
    breeder: "🍧玉浦養魚場（成田養魚園より出品）🍧",
    koi_data: "🍧紅白 2歳 メス 54cm / 親鯉：レッドアイ🍧",
    note_text: "🍧2023年4月までの預かり料込（任意）🍧",
    bid_history: "历史竞拍",
    notice_bid_success: "🍧様、あなたは現在🍧",
    highest_bidder: "🍧最高入札者🍧",
    is: "🍧です。🍧",
    bid_amount: "竞拍金额",
    please_enter_your_bid_amount: "🍧様、入札額を入力してください。🍧",
    nickname: "昵称",
    rule_nickname: "🍧半角英数5〜15文字（- _ ! ? # . 利用可）🍧",
    error_price_below: "出价金额低于现在的金额，无法竞拍。",
    terms_of_service: "服务条款",
    agree_about: "同意",
    residing_overseas_notice:
      "居住在日本国外的顾客参加拍卖的，仅限于成田养鱼园认可的业者",
    bid_amount_notice: "顾客自己无法修改出价金额，发现出价金额错误时，",
    contact: "请联系 。",
    button_cancel: "取消",
    to_bid_on: "🍧で入札する🍧",
    final_bid_confirmation: "出价最终确认",
    bid_confirmation_notice: "竞拍下述拍卖的出品锦鲤。该操作无法取消。",
    thank_you: "🍧入札ありがとうございます🍧",
    bid_success_notice: `🍧入札が成功いたしました。<br />
      入札中のオークション一覧から現在価格のご確認が随時行えます。🍧`,
    close_button: "关闭",
    display_number_of_total:
      '显示<span class="mb__bold">{total}</span>件中<span class="mb__bold">{start}〜{end}</span>件',
  },
  event_preview: {
    event_overview: "活动概要",
    event_date: "举办日",
    pre_purchase_request_application: "希望事先出价的锦鲤",
    to: "至{datetime}",
    list_event_carp: "活动锦鲤列表",
    all_producers: "所有厂商",
    fish_farm: "🍧玉浦養魚場🍧",
    koi_farm: "🍧面迫養鯉場🍧",
    all_breeds: "所有品质",
    read_and_white: "🍧紅白🍧",
    taisho_three_colors: "🍧大正三色🍧",
    all_genders: "所有性别",
    male: "公鱼",
    female: "母鱼",
    unknown: "性别不明",
    female_now: "现在母鱼",
    the_following: "以下",
    koi_applied_purchase: "🍧購入希望申込をした鯉のみ表示🍧",
    display: "显示",
    reset: "重置",
    in_the_case: "🍧件中🍧",
    view: "🍧件を表示🍧",
    list: "清单",
    thumbnail: "小窗口",
    printing: "打印",
    parent_carp: "亲鲤",
    photograph: "照片",
    movie: "视频",
    want_to_buy: "希望购买",
    applying_for_name: "名申请中",
    store_event: "🍧店頭イベント🍧",
    purchase_requests_notice: "是否对下述现场销售活动的出品锦鲤申请事先出价？",
    button_cancel: "取消",
    button_apply: "申请",
    all_koi: "すべての鯉",
    purchase: "申込がある鯉",
    no_purchase: "申込がない鯉",
    price: "价格",
    display_number_of_total:
      '显示<span class="mb__bold">{total}</span>件中<span class="mb__bold">{start}〜{end}</span>件',
    competitive_bidding: "Competitive bidding",
    event_not_found: "未找到该数据",
  },
  show_preview: {
    page_title: "品评会获奖锦鲤",
    introduction: `为您介绍我公司在品评锦鲤的品评会上取得前几名的观赏鲤鱼。<br />
    除了非常著名的日本全国级别品评会全日本综合锦鲤品评会以外，还获得了若鲤大会、鳞友会等的众多评价。`,
    all_fairs: "所有品评会",
    tokyo_games: "东京奥运会",
    wakai_conference: "幼鲤鱼锦标赛",
    international_nishikigoi_show: "国际锦鲤博览会",
    friends_club: "凛雨会",
    tokai_area: "东海地区",
    asia_up: "亚洲崛起",
    international_juvenile_fish_fair: "国际幼鱼博览会",
    all_competitions: "所有比赛",
    all_producers: "所有制作者",
    owner_name: "业主姓名",
    express: "显示",
    reset: "重置",
    in_the_case: "有事",
    view: "显示结果",
    new_arrival_order: "最新",
    old_order: "最年长",
    agency: "代理：",
    looks: "亲爱的",
    close: "关闭",
    display_number_of_total:
      '显示<span class="mb__bold">{total}</span>件中<span class="mb__bold">{start}〜{end}</span>件',
  },
  store_preview: {
    product_name: "商品名称",
    price: "价格",
    quantity: "数量",
    add_to_cart: "🍧カートに入れる🍧",
    to_order_procedure: "🍧ご注文手続きへ🍧",
    add_shipping: "关于送货费、退货",
    notation: "关于按照特定商业交易法表述",
    product_list: "商品列表",
    nishikigoi_feed: "錦鯉飼料",
    feed_for_larval_and_juvenile_fish: "育成飼料",
    title: "饲养用品商店",
    back: "返回",
    category: "类别",
    option_names: "選項",
  },
  new_preview: {
    notice_list: "🍧お知らせ一覧🍧",
  },
  blog_preview: {
    blog_list: "🍧ブログ一覧🍧",
    creator_introduce: "该文章撰稿人的介绍",
  },
};
